import type { ConfigType } from '@plone/registry';
import preFooter from '../components/Footer/preFooter';
import mainFooter from '../components/Footer/mainFooter';
import postFooter from '../components/Footer/postFooter';

export default function install(config: ConfigType) {

  config.registerSlotComponent({
    slot: 'preFooter',
    name: 'preFooterSAW',
    component: preFooter,
  });
  config.registerSlotComponent({
    slot: 'footer',
    name: 'footerSAW',
    component: mainFooter,
  });
  config.registerSlotComponent({
    slot: 'postFooter',
    name: 'postFooterSAW',
    component: postFooter,
  });

  return config;
}
